interface StatCardProps {
  title: string;
  value: string;
  change: string;
  isPositive: boolean;
  icon: string;
}

export default function DashboardStats() {
  const stats: StatCardProps[] = [
    {
      title: "Active Services",
      value: "12",
      change: "+2 this month",
      isPositive: true,
      icon: "ServerIcon"
    },
    {
      title: "Open Tickets",
      value: "3",
      change: "-5 from last week",
      isPositive: true,
      icon: "TicketIcon"
    },
    {
      title: "System Uptime",
      value: "99.8%",
      change: "Last 30 days",
      isPositive: true,
      icon: "ChartBarIcon"
    },
    {
      title: "Next Billing",
      value: "$4,850",
      change: "Due Feb 15, 2026",
      isPositive: false,
      icon: "CreditCardIcon"
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg border border-border p-6 hover:shadow-elevated transition-shadow duration-300"
        >
          <div className="flex items-start justify-between mb-4">
            <div className="w-12 h-12 bg-brand-primary/10 rounded-lg flex items-center justify-center">
              <span className="text-brand-primary text-2xl">📊</span>
            </div>
            <span className={`text-xs font-semibold px-2 py-1 rounded-full ${
              stat.isPositive 
                ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
            }`}>
              {stat.change}
            </span>
          </div>
          <h3 className="text-sm font-body font-semibold text-muted-foreground mb-1">
            {stat.title}
          </h3>
          <p className="text-3xl font-headline font-bold text-primary">
            {stat.value}
          </p>
        </div>
      ))}
    </div>
  );
}